import type { Location } from "@/content/locations";
import type { Service } from "@/content/services";
import { isPairedCity } from "@/content/language-pairs";
import { buildSeo } from "@/lib/seo";

/** Head metadata for a city x service page, shared by every route that can serve one. */
export function cityServiceHead(loc?: Location, svc?: Service) {
  if (!loc || !svc)
    return { meta: [{ title: "Not found" }, { name: "robots", content: "noindex" }] };
  const title = `${svc.title} in ${loc.city} | Freelancer Tamal`;
  const description = `${svc.title} for ${loc.city}, ${loc.country} businesses. ${svc.tagline} Transparent scope, real reporting, senior-led delivery.`;
  return buildSeo({
    title: title.length > 60 ? `${svc.title.split(" (")[0]} in ${loc.city}` : title,
    description,
    path: `/seo-services/${loc.slug}/${svc.slug}`,
    keywords: `${svc.title} ${loc.city}, ${svc.slug.replace(/-/g, " ")} ${loc.city}, ${loc.city} SEO consultant, ${loc.city} ${svc.slug.replace(/-/g, " ")}`,
    ogEyebrow: `${loc.city} · ${svc.title}`,
    ...(isPairedCity(loc.slug)
      ? { alternates: { bn: `/bn/seo-services/${loc.slug}/${svc.slug}` } }
      : {}),
  });
}
